import { useMemo, memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Footer as LayoutFooter } from 'antd/es/layout/layout';
import clsx from 'clsx';
import { useAppSelector } from 'app/hooks';
import useIsMobile from 'hooks/useIsMobile';
import If from 'components/If';
import { GENERAL } from 'utils/constants';
import { BRAND_CONFIG_MAPPING } from 'utils/brand-config';
import { selectUserSignInStatus } from 'services/session/sessionSelectors';
import { selectBrandCode } from 'services/brand/brandSelectors';
import { QaLoginPage } from 'testdata/constants';

// @Styles
import styles from './Footer.module.scss';

function Footer() {
  const isMobile = useIsMobile();
  const { pathname } = useLocation();
  const isLogin = useAppSelector(selectUserSignInStatus);
  const brandCode = useAppSelector(selectBrandCode);
  const currentYear = new Date().getFullYear();

  const footerClassNames = clsx(styles.footer, {
    [styles.fixedFooter]: !isMobile,
    [styles.logedInFooter]: isLogin,
  });

  const showFaqLink = useMemo(() => {
    return pathname.includes('enrollment');
  }, [pathname]);

  return (
    <LayoutFooter
      className={footerClassNames}
      data-qa-selector={QaLoginPage.textFooter}
    >
      <ul className={styles.serviceTermsLinks}>
        <li>
          <a
            href='/terms-of-service'
            target='_blank'
            rel='noreferrer'
            className={styles.link}
            data-qa-selector={QaLoginPage.linkTermsOfService}
          >
            {GENERAL.termsOfUse}
          </a>
        </li>
        <li>
          <a
            href='/privacy-policy'
            target='_blank'
            rel='noreferrer'
            className={styles.link}
            data-qa-selector={QaLoginPage.linkPrivacyPolicy}
          >
            {GENERAL.polices}
          </a>
        </li>
        <If condition={!isLogin && showFaqLink}>
          <li>
            <Link className={styles.link} to='/faq'>
              {GENERAL.faqs}
            </Link>
          </li>
        </If>
      </ul>
      <ul className={styles.copyrightText}>
        <li>
          &#169; {currentYear} {BRAND_CONFIG_MAPPING[brandCode].copyRightText}
        </li>
        <li>{GENERAL.noOneCanPreventAllIdentityTheft}</li>
      </ul>
    </LayoutFooter>
  );
}

export default memo(Footer);
